import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { provide, computed, watch, ref } from 'vue';
  import { FaqSectionArticlesStore, faqSectionsStore } from '@/stores';
  import { useRoute } from 'vue-router';
  import { IFaqSection } from '@/types/faq-section';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const faqSectionArticlesStore = ref(new FaqSectionArticlesStore());
  faqSectionArticlesStore.value.id = Number(route.params.id);
  faqSectionArticlesStore.value.fetchData();

  const currentSection = computed<IFaqSection>(() => {
    return faqSectionsStore.findItemById(String(route.params.id)) as IFaqSection;
  });

  provide('faqSectionArticlesStore', faqSectionArticlesStore);
  provide('currentSection', currentSection);

  watch(
    () => route.params.id,
    () => {
      faqSectionArticlesStore.value = new FaqSectionArticlesStore();
      faqSectionArticlesStore.value.id = Number(route.params.id);
      faqSectionArticlesStore.value.fetchData();
    }
  );


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    key: _unref(route).fullPath
  }))
}
}

})